import { render, staticRenderFns } from "./PluginCard.vue?vue&type=template&id=5079f79a&scoped=true"
import script from "./PluginCard.vue?vue&type=script&lang=ts"
export * from "./PluginCard.vue?vue&type=script&lang=ts"
import style0 from "./PluginCard.vue?vue&type=style&index=0&id=5079f79a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5079f79a",
  null
  
)

export default component.exports